import { Prose } from '~/portal/components/ProseWrapper'
import { sanitizeLandingPageHtml } from '~/portal/utils/shared/landingPage'

export interface HeroSectionProps {
  content?: string | null
  fontFamily?: string
}

export const HeroSection = ({ content, fontFamily }: HeroSectionProps) => {
  const html = sanitizeLandingPageHtml(content || '').trim()

  if (!html) {
    return null
  }

  return (
    <header className="sp-hero max-w-7xl w-full mx-auto my-6 md:my-9 xl:my-12 px-6 md:px-9 xl:px-[3.75rem]" role="banner">
      <div className="sp-hero-description flow-root" data-testid="consumer-hero-html">
        <Prose isLandingPage={true} style={{ fontFamily }}>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </Prose>
      </div>
    </header>
  )
}
